<section class="quotation-document-wrapper">
  <div class="box">
    <div class="box__left">
      <div class="box__subheading color-blue">
        {{ 'QUOTATION.DOCUMENT.SUB_HEADING' | translate }}
      </div>
      <!-- deskop heading -->
      <h1 class="box__heading color-gray box__heading {{ translate.currentLang }}"
        >{{ 'QUOTATION.DOCUMENT.HEADING' | translate }}
      </h1>

      <div class="box__heading-detail box__heading--mw">
        {{ 'QUOTATION.DOCUMENT.DETAIL' | translate }}
      </div>
      <div class="box__btn">
        <a
          href="https://auth.flowaccount.com/{{ translate.currentLang }}/Account/Register"
          rel="noopener noreferrer"
          class="flowbtn app-btn box__btn--layout"
          (click)="setCookiePreviousPath()"
        >
          {{ 'QUOTATION.DOCUMENT.BECOME_PARTNER_BUTTON' | translate }}
        </a>
      </div>
    </div>
    <div class="box__right">
      <picture>
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-section-1-min.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/functions/quotation/quotation-section-1_v2.png"
          width="100%"
          loading="eager"
          alt="{{ getAltText }}"
          title="{{ getAltText }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
